<template>
  <div>
    <b-row>
      <b-col md="6" class="my-1">
        <h3 class="text-themecolor">Portal {{$t('carpetline.gebruikers')}}</h3>
      </b-col>
      <b-col md="6" class="my-1">
        <div class="pull-right">
          <b-button variant="themecolor" size="sm" @click="goTo('create')" class="mr-1">
            <i class="fa fa-plus fa-fw" aria-hidden="true"></i> {{$t('buttons.nieuwegebruiker')}}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <!-- User Interface controls -->
            <b-row>
              <b-col md="12" class="my-1">
                <b-form-group class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- User Interface controls -->

            <!-- Main table element -->
            <b-row>
              <b-col md="12">
                <b-table show-empty
                        stacked="md"
                        :empty-text="getEmptyText(count)"
                        :busy="count == -1"
                        class="table-hover"
                        :items="usercustomerrelations"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        @filtered="onFiltered"
                        @row-clicked="onRowClicked">
                        <template v-slot:cell(customer)="data">{{data.item.customerRelation.tag}} - {{data.item.customerRelation.name}}</template>
                        <template v-slot:cell(name)="data">{{data.item.user.fullName}}</template>
                        <template v-slot:cell(emailAddress)="data">{{data.item.user.emailAddress.address}}</template>
                        <template v-slot:table-busy>
                          <PreLoader/>
                        </template>
                </b-table>
              </b-col>
            </b-row>
            <!-- Main table element -->

            <!-- Pagination controls -->
            <b-row>
              <b-col md="12" lg="5" >
                <b-form-group label-cols :label="$t('datatables.perpagina')">
                  <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
              </b-col>
              <b-col md="12" lg="7">
                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- Pagination controls -->
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  //Import store
  import {mapActions, mapGetters} from 'vuex';
  import PreLoader from '@/components/root/Preloader';
  import { getEmptyText } from '@/views/root/GetMessageTextHelper';
  
  export default {
  name: `users-index`,
  components: {PreLoader},
  data () {
    return {
      currentPage: 1,
      perPage: 50,
      pageOptions: [ 50, 100, 200 ],
      filter: null,
      count: -1
    }
  },
  computed: {
    fields() {
      return [
        { key: 'customer', label: this.$i18n.t('datatables.klantrelatie'), sortable: true },
        { key: 'name', label: this.$i18n.t('datatables.gebruiker'), sortable: true },
        { key: 'emailAddress', label: this.$i18n.t('datatables.emailadres'), sortable: true }
      ]
    },
    ...mapGetters ('carpetline', ['usercustomerrelations']),
  },
  methods: {
    ...mapActions('carpetline',['all']),
    onFiltered (filteredItems) {
      this.count = filteredItems.length;
      this.currentPage = 1
    },
    onRowClicked(item) {
      this.$router.push({ name: `user-customer-relations:detail`, params: { userId: item.id } });
    },
    goTo(name) {
      this.$router.push({ name: `user-customer-relations:${name}` });
    },
    getEmptyText,
  },
  created() {
    const vm = this;
    vm.all({
      resource: 'user-customer-relations'
    })
    .then((data) => {
      vm.count = data.result.length;
    });
  }
}
</script>
